import { createStore } from "vuex";
// TODO Consider VuexPersist for state persistence, specially for user session management (storing token)
// import VuexPersist from 'vuex-persist';

import spendingCategory from "@/store/modules/spendingCategory";
import userSession from "@/store/modules/userSession";
import userAccount from "@/store/modules/userAccount";
import budget from "@/store/modules/budget";
import weeklyOutlooks from "@/store/modules/weeklyOutlooks";
import pendingActions from "@/store/modules/pendingActions";
import bankingInstitutions from "@/store/modules/bankingInstitutions";

const store = createStore({
  state() {
    return {
      count: 0,
    };
  },
  mutations: {
    increment(state) {
      state.count++;
    },
  },
  actions: {
    // actions can contain asynchronous logic and commit mutations
  },
  getters: {
    // getters can compute derived state based on store state
  },
  modules: {
    userSession,
    userAccount,
    spendingCategory,
    budget,
    weeklyOutlooks,
    pendingActions,
    bankingInstitutions,
  },
});

export default store;
